import { useState, useEffect, useCallback } from 'react';
import amazonService from '../services/amazonService';

export default function useAmazonBalance() {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [retryCount, setRetryCount] = useState(0);

  const fetchAmazonBalance = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await amazonService.getAccountBalance();
      setBalance(data);
      setRetryCount(0);
    } catch (err) {
      setError("Impossible de récupérer le solde Amazon");
      if (retryCount < 2) {
        setRetryCount(prev => prev + 1);
        setTimeout(fetchAmazonBalance, 5000);
      }
    } finally {
      setLoading(false);
    }
  }, [retryCount]);

  useEffect(() => {
    fetchAmazonBalance();
    // eslint-disable-next-line
  }, []);

  return {
    balance,
    loading,
    error,
    refresh: fetchAmazonBalance
  };
} 